export default __webpack_public_path__ + "static/media/team-foto1-color.06166627.png";